export function getLanguageName(value: string): string {
  return value.replace(/([a-z])([A-Z])/g, '$1 $2');
}
